import React from "react";
import truckLogo from "../../Assets/TruckwithLogo.png";
import "./Truck.css";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/all";
import gsap from "gsap";
export default function Truck() {
  gsap.registerPlugin(useGSAP, ScrollTrigger);
  useGSAP(
    () => {
      gsap.to(".truckImagesWrapper .pp", {
        scrollTrigger: {
          trigger: ".truckImagesWrapper",
          scroller: "body",
          //   markers: true,
          start: "top 40%",
          end: "bottom 50%",
          scrub: 2,
        },
        xPercent: -50,
        left: "40%",
        yPercent: -0,
        top: "150%",
        position: "relative",
        transform: "rotate(0deg)",
        // marginTop: 50,
        flexDirection: "column",
        justifyContent: "center",
        delay: 1,
        duration: 2,
        scale: 0.5,
        opacity: "0",
      });
      gsap.to(".truck .truckImg", {
        scrollTrigger: {
          trigger: ".truckWrapper",
          scroller: "body",
          // markers: true,
          start: "top 30%",
          end: "bottom 45%",
          scrub: 2,
        },
        y: 350,
        opacity: 0,
        scale: 0.6,
      });
      gsap.to(".deliveryMessage .deliverymesssageText", {
        scrollTrigger: {
          trigger: ".deliveryMessage",
          scroller: "body",
            // markers: true,
          start: "top 70%",
          end: "bottom 80%",
          scrub: 3,
        },

        opacity: 1,
      });
    }
    // { scope: wrapper }
  );
  return (
    <>
      <div className="deliveryTextwrapper w-[70%] flex justify-center items-center mt-8">
        <p className="text-center text-[18px] md:text-[32px] lg:text-[40px] font-[600]">
          Discover a laundry service that combines modern technology with
          eco-friendly solutions for an unmatched experience. From everyday
          laundry to specialty garments, we’re here to make your life easier —
          one clean item at a time.
        </p>
      </div>
      <div className="truckWrapper mt-8">
        <div className="truck">
          <img src={truckLogo} alt="truck" className="h-[40vh] truckImg" />
        </div>
        <div className="deliveryMessage">
          <div className="deliverymesssageText">Delivered at Your Doorstep</div>
        </div>
      </div>
    </>
  );
}
